const React = require('react');
const Slider = require('rc-slider').default;
const PropTypes = require('prop-types');

class BumpBidSlider extends React.Component {
  bidTierSteps() {
    const marks = {};
    marks[0.0] = I18n.t('js.bump.noBid');
    this.props.bidTiers.forEach((tier) => {
      marks[parseFloat(tier[1])] = tier[0];
    });
    return marks;
  }

  get maxBid() {
    return parseFloat(this.props.bidTiers[this.props.bidTiers.length - 1][1]);
  }

  get currentBid() {
    return this.props.bid ? parseFloat(this.props.bid) : 0.0;
  }

  get bidError() {
    return (!this.props.deleted && (this.props.error || this.bidEmpty));
  }

  get bidEmpty() {
    return this.props.bid === '' || this.props.bid === null || this.props.bid === undefined;
  }

  renderMessage() {
    const displaySuccess = !this.props.error && this.props.bidChange;
    if (this.props.error) {
      return (
        <div className="bid-change__error">
          <h4 className="bid-change__error__text">
            {I18n.t('js.bump.errorBid')}
          </h4>
        </div>
      );
    } else if (displaySuccess && this.props.deleted) {
      return (
        <div className="bid-change__success">
          <h4 className="bid-change__success__text">
            {I18n.t('js.bump.successBidDelete')}
          </h4>
          <button
            className="bid-change__dismiss"
            onClick={() => this.props.changeDismiss()}
          />
        </div>
      );
    } else if (displaySuccess) {
      return (
        <div className="bid-change__success">
          <h4 className="bid-change__success__text">
            {I18n.t('js.bump.successBid', { percent: (parseFloat(this.props.setBid) * 100).toFixed(1) })}
          </h4>
          <button
            className="bid-change__dismiss"
            onClick={() => this.props.changeDismiss()}
          />
        </div>
      );
    }
    return null;
  }

  shouldRenderDeleteMessage() {
    return !this.props.error && this.props.deleted && this.currentBid === 0.0;
  }

  renderZeroBidNote() {
    if (!this.shouldRenderDeleteMessage()) { return null; }

    const deleteMessage = I18n.t('js.bump.deleteBidBumpV2')
    return <div className="size-90 mtb-1">{deleteMessage}</div>;
  }

  render() {
    if (this.bidError === true) {
      return (
        <div className="alert alert-warning">{I18n.t('js.bump.bidFetchError')}</div>
      );
    }

    return (
      <div>
        <div className="reverb-rc-slider">
          <Slider
            dots
            step={this.props.tierIncrement}
            marks={this.bidTierSteps()}
            min={0.0}
            max={this.maxBid}
            value={this.currentBid}
            onChange={newBid => this.props.bidChanged(newBid)}
            onAfterChange={newBid => this.props.updateBid(newBid)}
          />
        </div>
        <div className="bid-change">
          {this.renderMessage()}
        </div>
        {this.renderZeroBidNote()}
      </div>
    );
  }
}

BumpBidSlider.propTypes = {
  bidTiers: PropTypes.array.isRequired,
  tierIncrement: PropTypes.number.isRequired,
  bid: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  setBid: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  updateBid: PropTypes.func,
  bidChanged: PropTypes.func,
  error: PropTypes.bool,
  bidChange: PropTypes.bool,
  deleted: PropTypes.bool,
  changeDismiss: PropTypes.func,
};

module.exports = BumpBidSlider;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/bump_bid_slider.jsx